import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
//区域代理开发
{
  path: "/package_deliver_merchant_apply",
  component: function component() {
    return import("../../../views/package-deliver-merchant/apply.vue");
  },
  name: "package_deliver_merchant_apply",
  meta: {
    title: "招商员申请",
    foot: true
  }
}];